import React from "react";
import Box from "@mui/material/Box";
import { appBarHeight } from "../styleTs/styleTs";

const AppBarSpace: React.FC = () => {
  return <Box sx={{ height: `${appBarHeight}px` }}></Box>;
};

export default AppBarSpace;
